import Chip, { ChipProps } from "@mui/material/Chip";
import {
  SpecialOrderMode,
  SpecialOrderStatus,
} from "../../types/special-order.type";
import {
  MODE_COLOR,
  MODE_LABEL,
  MODE_SHORT_LABEL,
  STATUS_COLOR,
  STATUS_LABEL,
} from "./data";

export function StatusChip({
  status,
  size = "small",
}: Readonly<{ status: SpecialOrderStatus; size?: ChipProps["size"] }>) {
  return (
    <Chip
      size={size}
      label={STATUS_LABEL[status] ?? status}
      color={STATUS_COLOR[status] ?? "default"}
      variant={status === "draft" ? "outlined" : "filled"}
    />
  );
}

/** `short` = just the letter, for table rows; otherwise the full "แบบ B · ลูกค้ามารับ". */
export function ModeChip({
  mode,
  short = false,
  size = "small",
}: Readonly<{ mode: SpecialOrderMode; short?: boolean; size?: ChipProps["size"] }>) {
  return (
    <Chip
      size={size}
      label={short ? MODE_SHORT_LABEL[mode] : MODE_LABEL[mode]}
      color={MODE_COLOR[mode]}
      sx={short ? { minWidth: 32, fontWeight: 700 } : { fontWeight: 600 }}
    />
  );
}
